/**
 * Subscribe & Save popover – show on trigger click, close on toggle / CTA / outside / Escape.
 * Load from theme layout so it runs when cart content is injected.
 */
(function() {
  if (window.__subscribePopoverCartInitialized) return;
  window.__subscribePopoverCartInitialized = true;

  var BOUND = 'data-subscribe-popover-bound';

  (function ensureLoadingStyles() {
    if (document.getElementById('subscribe-popover-cart-loading-styles')) return;
    var style = document.createElement('style');
    style.id = 'subscribe-popover-cart-loading-styles';
    style.textContent = [
      '.popover-subscribe-btn--loading { pointer-events: none; }',
      '.popover-subscribe-btn__spinner { display: inline-block; width: 1em; height: 1em; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%; vertical-align: middle; margin-right: 0.5em; animation: subscribe-popover-spin 0.7s linear infinite; }',
      '@keyframes subscribe-popover-spin { to { transform: rotate(360deg); } }'
    ].join('\n');
    document.head.appendChild(style);
  })();

  function unbindPopoverReposition(popover) {
    if (!popover || !popover._subscribeRepositionState) return;
    var state = popover._subscribeRepositionState;
    state.roots.forEach(function(root) {
      root.removeEventListener('scroll', state.onReposition, true);
    });
    window.removeEventListener('resize', state.onReposition);
    delete popover._subscribeRepositionState;
    delete popover._subscribeTriggerBtn;
  }

  function getPopoverScrollRoots(button) {
    var roots = [];
    var content = button.closest('.cart-drawer__content');
    var items = button.closest('scroll-hint.cart-drawer__items');
    var dialog = button.closest('dialog');
    if (content) roots.push(content);
    if (items && roots.indexOf(items) === -1) roots.push(items);
    if (dialog && roots.indexOf(dialog) === -1) roots.push(dialog);
    return roots;
  }

  function bindPopoverReposition(popover, button) {
    unbindPopoverReposition(popover);
    popover._subscribeTriggerBtn = button;

    function onReposition() {
      var trigger = popover._subscribeTriggerBtn;
      if (!trigger || !popover.hasAttribute('data-subscribe-open')) return;
      if (!document.contains(trigger)) {
        closePopover(popover);
        return;
      }
      positionPopover(trigger, popover);
    }

    var roots = getPopoverScrollRoots(button);
    roots.forEach(function(root) {
      root.addEventListener('scroll', onReposition, { capture: true, passive: true });
    });
    window.addEventListener('resize', onReposition, { passive: true });
    popover._subscribeRepositionState = { roots: roots, onReposition: onReposition };
  }

  /**
   * Anchor-relative top/left for position:fixed inside the cart drawer (matches pre-scroll-follow math).
   * Scroll/resize handlers re-call this with fresh getBoundingClientRect() values.
   */
  function positionPopover(button, popover) {
    if (!button || !popover) return;
    var container = button.closest('.subscription-upgrade-container');
    var anchor = container
      ? container.closest('dialog') || container.closest('cart-drawer-component') || document.body
      : document.body;
    var btnRect = button.getBoundingClientRect();
    var anchorRect = anchor.getBoundingClientRect();
    var isMobile = window.innerWidth <= 768;
    var gap = 8;
    var edge = 12;
    var popoverW = isMobile
      ? Math.min(300, anchorRect.width - edge * 2)
      : Math.min(320, Math.max(200, anchorRect.width * 0.9));
    var top = (btnRect.top - anchorRect.top) + btnRect.height + gap;
    var btnTopInAnchor = btnRect.top - anchorRect.top;

    if (isMobile) {
      popover.style.left = '50%';
      popover.style.setProperty('transform', 'translateX(-50%)', 'important');
    } else {
      var left = (btnRect.left - anchorRect.left) + btnRect.width / 2 - popoverW / 2;
      left = Math.max(0, Math.min(left, anchorRect.width - popoverW));
      popover.style.left = left + 'px';
      popover.style.removeProperty('transform');
    }

    top = Math.max(0, Math.min(top, anchorRect.height - 80));

    var spaceBelow = anchorRect.height - top - edge;
    var spaceAbove = btnTopInAnchor - gap;
    var maxH = Math.min(anchorRect.height * 0.9, spaceBelow, window.innerHeight * 0.9);

    if (maxH < 120 && spaceAbove > spaceBelow) {
      maxH = Math.min(anchorRect.height * 0.9, spaceAbove, window.innerHeight * 0.9);
      top = Math.max(0, btnTopInAnchor - gap - maxH);
    }

    maxH = Math.max(120, maxH);

    popover.style.top = top + 'px';
    popover.style.width = popoverW + 'px';
    popover.style.setProperty('max-height', maxH + 'px', 'important');
  }

  function closePopover(popover) {
    if (!popover) return;
    unbindPopoverReposition(popover);
    popover.removeAttribute('data-subscribe-open');
    popover.style.removeProperty('display');
    popover.style.removeProperty('opacity');
    popover.style.removeProperty('visibility');
    popover.style.removeProperty('pointer-events');
    popover.style.removeProperty('position');
    popover.style.removeProperty('z-index');
    popover.style.removeProperty('max-height');
    popover.style.removeProperty('overflow-y');
    popover.style.left = '';
    popover.style.top = '';
    popover.style.width = '';
    popover.style.transform = '';
  }

  function closeAllOpen() {
    document.querySelectorAll('.subscribe-popover[data-subscribe-open]').forEach(closePopover);
  }

  function openPopoverForButton(button) {
    var container = button.closest('.subscription-upgrade-container');
    if (!container) return;
    var livePopover = container.querySelector('.subscribe-popover');
    if (!livePopover) return;

    closeAllOpen();

    livePopover.style.setProperty('display', 'block', 'important');
    livePopover.style.setProperty('opacity', '1', 'important');
    livePopover.style.setProperty('visibility', 'visible', 'important');
    livePopover.style.setProperty('pointer-events', 'auto', 'important');
    livePopover.style.setProperty('position', 'fixed', 'important');
    livePopover.style.setProperty('z-index', '999999', 'important');
    livePopover.style.setProperty('max-height', '90vh', 'important');
    livePopover.style.setProperty('overflow-y', 'auto', 'important');

    positionPopover(button, livePopover);
    livePopover.setAttribute('data-subscribe-open', '1');
    bindPopoverReposition(livePopover, button);
    syncSubscribeCtaFromFrequencySelect(livePopover);
  }

  function getFrequencySelectInPopover(popover) {
    return popover && popover.querySelector ? popover.querySelector('.subscribe-popover-frequency-select') : null;
  }

  /** Creatine cart popover: require a frequency before enabling SUBSCRIBE & SAVE. */
  function syncSubscribeCtaFromFrequencySelect(popover) {
    var btn = popover && popover.querySelector ? popover.querySelector('.popover-subscribe-btn') : null;
    var sel = getFrequencySelectInPopover(popover);
    if (!btn || !sel) return;
    btn.disabled = !sel.value;
  }

  /** Popover frequency select: sync CTA on input/change (change alone often waits until blur). */
  function bindSubscribePopoverFrequencySelectSync() {
    if (bindSubscribePopoverFrequencySelectSync._done) return;
    bindSubscribePopoverFrequencySelectSync._done = true;

    function handleFrequencySelectUpdate(e) {
      var sel = e.target;
      if (!sel || !sel.matches) return;
      if (!sel.matches('.subscribe-popover .subscribe-popover-frequency-select')) return;
      if (sel.classList.contains('cart-creatine-frequency-change-select')) return;
      var popover = sel.closest('.subscribe-popover');
      if (popover) syncSubscribeCtaFromFrequencySelect(popover);
    }

    document.addEventListener('input', handleFrequencySelectUpdate, true);
    document.addEventListener('change', handleFrequencySelectUpdate, true);
    document.addEventListener(
      'click',
      function (e) {
        var sel = e.target;
        if (!sel || sel.tagName !== 'SELECT') return;
        if (!sel.matches('.subscribe-popover .subscribe-popover-frequency-select')) return;
        if (sel.classList.contains('cart-creatine-frequency-change-select')) return;
        var popover = sel.closest('.subscribe-popover');
        if (!popover) return;
        setTimeout(function () {
          syncSubscribeCtaFromFrequencySelect(popover);
        }, 0);
      },
      true
    );
  }

  function bindButton(button) {
    if (button.getAttribute(BOUND)) return;
    button.setAttribute(BOUND, '1');
    var container = button.closest('.subscription-upgrade-container');
    if (!container) return;
    var popover = container.querySelector('.subscribe-popover');
    if (!popover) return;

    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openPopoverForButton(button);
    });
  }

  /** US store global 10%/15% plans (keep in sync with subscription-container.js). */
  var SUBSCRIPTION_SELLING_PLAN_ID = 1607434294;
  var MULTI_SUBSCRIPTION_SELLING_PLAN_ID = 1662681142;
  /** Creatine (US + MX inventory) — per-frequency selling plans; do not normalize to global 10%/15% plans. */
  var CREATINE_CART_VARIANT_IDS = [44140962873398, 44239538356278];

  function isCreatineCartVariantId(variantId) {
    return CREATINE_CART_VARIANT_IDS.indexOf(parseInt(variantId, 10)) !== -1;
  }
  /** Subscription bonus freebie — US vs MX inventory. */
  var SUBSCRIPTION_BONUS_VARIANT_ID_US = 44652639256630;
  var SUBSCRIPTION_BONUS_VARIANT_ID_MX = 44652631392310;
  var SUBSCRIPTION_BONUS_VARIANT_IDS = [
    SUBSCRIPTION_BONUS_VARIANT_ID_US,
    SUBSCRIPTION_BONUS_VARIANT_ID_MX
  ];
  /** Sample pack subscription plan when auto-added with a cart subscription. */
  var SUBSCRIPTION_BONUS_SELLING_PLAN_ID = 2200830006;

  function getShopCountryCode() {
    var formEl = document.querySelector('localization-form-component');
    if (formEl) {
      var fromAttr = (formEl.getAttribute('data-initial-country') || '').trim();
      if (fromAttr) return fromAttr.toUpperCase();
    }
    var countryInput = document.querySelector('form.localization-form input[name="country_code"]');
    if (countryInput && countryInput.value) {
      return String(countryInput.value).trim().toUpperCase();
    }
    return 'US';
  }

  function getSubscriptionBonusVariantId() {
    return getShopCountryCode() === 'MX'
      ? SUBSCRIPTION_BONUS_VARIANT_ID_MX
      : SUBSCRIPTION_BONUS_VARIANT_ID_US;
  }

  function isSubscriptionBonusVariantId(variantId) {
    return SUBSCRIPTION_BONUS_VARIANT_IDS.indexOf(parseInt(variantId, 10)) !== -1;
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '';
  var invalidPlanByVariant = {};
  var isReconcilingPlans = false;
  var isReconcilingBonus = false;
  var cartSideEffectsTimer = null;
  var bonusSyncTimer = null;
  /** >0 while subscription lines are being removed/re-added for selling-plan normalization. */
  var planMutationDepth = 0;
  var lastReconcileAt = 0;
  var reconcileRetryTimer = null;
  var RECONCILE_MIN_INTERVAL_MS = 1200;
  var CART_SIDE_EFFECTS_DELAY_MS = 550;
  var USER_LINE_REMOVE_MS = 4000;
  var DEFERRED_SIDE_EFFECTS_MS = 3000;
  var POST_REMOVE_SIDE_EFFECTS_MS = 2800;
  var CART_CHANGE_RETRY_MAX = 3;
  var userLineRemoveGeneration = 0;
  /** True while checkout must stay disabled until 10%/15% plan reconcile (+ bonus) finishes. */
  var subscriptionCheckoutLock = false;
  var awaitingPostRemoveSideEffects = false;
  var awaitingDeferredSideEffects = false;
  var checkoutUnlockPollTimer = null;

  function pauseCartSideEffects(ms) {
    window.__cartSideEffectsPausedUntil = Date.now() + (ms || 900);
  }

  function isUserLineRemoveActive() {
    return Date.now() < (window.__cartUserLineRemoveUntil || 0);
  }

  function cancelPendingCartSideEffects() {
    if (cartSideEffectsTimer) {
      clearTimeout(cartSideEffectsTimer);
      cartSideEffectsTimer = null;
      awaitingDeferredSideEffects = false;
    }
    if (bonusSyncTimer) {
      clearTimeout(bonusSyncTimer);
      bonusSyncTimer = null;
    }
    if (reconcileRetryTimer) {
      clearTimeout(reconcileRetryTimer);
      reconcileRetryTimer = null;
    }
  }

  function getCheckoutButtons() {
    return document.querySelectorAll('#checkout, .cart__checkout-button, button[name="checkout"]');
  }

  function getAcceleratedCheckoutContainers() {
    return document.querySelectorAll(
      '.additional-checkout-buttons, shopify-accelerated-checkout-cart, [additional-checkout-buttons]'
    );
  }

  function applyCheckoutLockedUi(locked) {
    getCheckoutButtons().forEach(function(btn) {
      if (locked) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('data-subscription-checkout-locked', '1');
      } else if (btn.getAttribute('data-subscription-checkout-locked') === '1') {
        btn.removeAttribute('data-subscription-checkout-locked');
        btn.removeAttribute('aria-busy');
        var bubble = document.querySelector('.cart-bubble__text-count');
        var count = bubble ? parseInt((bubble.textContent || '').trim(), 10) : NaN;
        btn.disabled = !isNaN(count) && count <= 0;
      }
    });
    getAcceleratedCheckoutContainers().forEach(function(el) {
      if (locked) {
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('data-subscription-checkout-locked', '1');
      } else if (el.getAttribute('data-subscription-checkout-locked') === '1') {
        el.style.pointerEvents = '';
        el.style.opacity = '';
        el.removeAttribute('aria-disabled');
        el.removeAttribute('data-subscription-checkout-locked');
      }
    });
  }

  function shouldKeepCheckoutLocked() {
    return (
      awaitingPostRemoveSideEffects ||
      awaitingDeferredSideEffects ||
      isUserLineRemoveActive() ||
      isCartMutationBusy() ||
      !!cartSideEffectsTimer ||
      !!bonusSyncTimer ||
      !!reconcileRetryTimer
    );
  }

  function lockCheckoutForSubscriptionUpdate() {
    subscriptionCheckoutLock = true;
    window.__subscriptionCheckoutLocked = true;
    applyCheckoutLockedUi(true);
    scheduleCheckoutUnlockPoll();
  }

  function refreshCheckoutLockUi() {
    if (subscriptionCheckoutLock || shouldKeepCheckoutLocked()) {
      applyCheckoutLockedUi(true);
    }
  }

  function tryUnlockCheckoutForSubscriptionUpdate() {
    // Do not gate only on awaiting* flags — those can stick if a reconcile done() is dropped.
    if (
      isUserLineRemoveActive() ||
      isCartMutationBusy() ||
      cartSideEffectsTimer ||
      bonusSyncTimer ||
      reconcileRetryTimer
    ) {
      scheduleCheckoutUnlockPoll();
      return;
    }
    cartFetch()
      .then(function(cart) {
        if (
          isUserLineRemoveActive() ||
          isCartMutationBusy() ||
          cartSideEffectsTimer ||
          bonusSyncTimer ||
          reconcileRetryTimer
        ) {
          scheduleCheckoutUnlockPoll();
          return;
        }
        if (cart && needsPlanNormalization(cart)) {
          lockCheckoutForSubscriptionUpdate();
          if (!awaitingPostRemoveSideEffects && !awaitingDeferredSideEffects) {
            awaitingDeferredSideEffects = true;
            reconcilePlansFromCartState(function() {
              scheduleSyncSubscriptionBonus();
              afterPlansAndBonusSettled(function() {
                awaitingDeferredSideEffects = false;
                tryUnlockCheckoutForSubscriptionUpdate();
              });
            });
          } else {
            scheduleCheckoutUnlockPoll();
          }
          return;
        }
        awaitingPostRemoveSideEffects = false;
        awaitingDeferredSideEffects = false;
        subscriptionCheckoutLock = false;
        window.__subscriptionCheckoutLocked = false;
        applyCheckoutLockedUi(false);
      })
      .catch(function() {
        scheduleCheckoutUnlockPoll();
      });
  }

  function scheduleCheckoutUnlockPoll() {
    if (checkoutUnlockPollTimer) return;
    checkoutUnlockPollTimer = setTimeout(function() {
      checkoutUnlockPollTimer = null;
      if (!subscriptionCheckoutLock && !shouldKeepCheckoutLocked()) return;
      tryUnlockCheckoutForSubscriptionUpdate();
    }, 280);
  }

  function afterPlansAndBonusSettled(done) {
    function poll() {
      if (isCartMutationBusy() || bonusSyncTimer) {
        setTimeout(poll, 200);
        return;
      }
      setTimeout(function() {
        if (isCartMutationBusy() || bonusSyncTimer) {
          poll();
          return;
        }
        if (typeof done === 'function') done();
      }, CART_SIDE_EFFECTS_DELAY_MS + 80);
    }
    poll();
  }

  function isSubscriptionCheckoutBlocked() {
    return (
      subscriptionCheckoutLock ||
      window.__subscriptionCheckoutLocked === true ||
      shouldKeepCheckoutLocked()
    );
  }

  function bindCheckoutSubmitGuard() {
    if (bindCheckoutSubmitGuard._done) return;
    bindCheckoutSubmitGuard._done = true;
    document.addEventListener(
      'submit',
      function(e) {
        if (!isSubscriptionCheckoutBlocked()) return;
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        var formId = form.id || '';
        var action = (form.getAttribute('action') || '').toLowerCase();
        var isCartCheckout =
          formId === 'cart-form' ||
          form.querySelector('#checkout, .cart__checkout-button, button[name="checkout"]') ||
          (action.indexOf('/cart') !== -1 && form.querySelector('button[name="checkout"]'));
        if (!isCartCheckout) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
    document.addEventListener(
      'click',
      function(e) {
        if (!isSubscriptionCheckoutBlocked()) return;
        var btn = e.target && e.target.closest
          ? e.target.closest('#checkout, .cart__checkout-button, button[name="checkout"]')
          : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );
  }

  function markUserLineRemove() {
    userLineRemoveGeneration++;
    window.__cartUserLineRemoveUntil = Date.now() + USER_LINE_REMOVE_MS;
    pauseCartSideEffects(USER_LINE_REMOVE_MS);
    cancelPendingCartSideEffects();
    awaitingPostRemoveSideEffects = true;
    lockCheckoutForSubscriptionUpdate();
    return userLineRemoveGeneration;
  }

  function isCartSideEffectsPaused() {
    return Date.now() < (window.__cartSideEffectsPausedUntil || 0);
  }

  function isCartMutationBusy() {
    return (
      isCartSideEffectsPaused() ||
      planMutationDepth > 0 ||
      isReconcilingPlans ||
      isReconcilingBonus
    );
  }

  /** cart:update sources we emit — do not re-run reconcile/bonus on these (prevents feedback loops). */
  var INTERNAL_CART_UPDATE_SOURCES = {
    'subscribe-popover-plan-reconcile': true,
    'subscribe-popover-cart': true,
    'subscribe-popover-bonus-cleanup': true,
    'subscribe-popover-bonus-ensure': true,
    'cart-creatine-frequency-change': true,
    'subscription-container-bonus': true,
    'header-actions-auto-add': true,
    'localization-country-change': true,
    'subscribe-popover-cart-mutation': true,
    'tybo-post-remove-complete': true
  };

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function(el) {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        ids.push(el.dataset.sectionId);
      }
    });
    return ids;
  }

  function dispatchCartUpdateWithSections(cartResponse, source) {
    if (!cartResponse || !cartResponse.sections) return;
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartResponse,
          data: {
            source: source || 'subscribe-popover-cart-mutation',
            sections: cartResponse.sections,
            itemCount: cartResponse.item_count
          }
        }
      })
    );
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function cartChangeWithSections(payload, source) {
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) {
          throw new Error((data && (data.description || data.message)) || 'Cart update failed');
        }
        dispatchCartUpdateWithSections(data, source);
        return data;
      });
    });
  }

  function addOneTimeLineWithSections(variantId, qty, source) {
    var body = {
      id: parseInt(variantId, 10),
      quantity: Math.max(1, parseInt(qty, 10) || 1)
    };
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.json().then(function(data) {
        var ok = r.ok && !(data && data.status === 422);
        if (ok && data.sections) {
          dispatchCartUpdateWithSections(data, source || 'subscribe-popover-cart-mutation');
        }
        return { ok: ok, data: data };
      });
    });
  }

  function addSubscriptionBonusLineWithSections(variantId, qty, source) {
    var body = {
      id: parseInt(variantId, 10),
      quantity: Math.max(1, parseInt(qty, 10) || 1),
      selling_plan: SUBSCRIPTION_BONUS_SELLING_PLAN_ID
    };
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.json().then(function(data) {
        var ok = r.ok && !(data && data.status === 422);
        if (ok && data.sections) {
          dispatchCartUpdateWithSections(data, source || 'subscribe-popover-bonus-ensure');
        }
        return { ok: ok, data: data };
      });
    });
  }

  function addSubscriptionBonusLine(variantId, qty) {
    return addSubscriptionLine(variantId, qty, SUBSCRIPTION_BONUS_SELLING_PLAN_ID);
  }

  function getLineIndexForKey(cartComponent, lineKey) {
    if (!cartComponent || !lineKey) return 0;
    var rows = cartComponent.querySelectorAll('tbody tr[data-key]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-key') === lineKey) {
        return i + 1;
      }
    }
    return 0;
  }

  function isInternalCartUpdateSource(source) {
    return !!(source && INTERNAL_CART_UPDATE_SOURCES[source]);
  }

  function cartFetch() {
    return fetch(root + 'cart.js?' + Date.now(), { cache: 'no-store' }).then(function(r) { return r.json(); });
  }

  function addSubscriptionLine(variantId, qty, sellingPlanId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: qty,
        selling_plan: sellingPlanId
      })
    }).then(function(r) {
      return r.json().then(function(data) {
        return { ok: r.ok, data: data };
      });
    });
  }

  function addOneTimeLine(variantId, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: Math.max(1, parseInt(qty, 10) || 1)
      })
    }).then(function(r) {
      return r.json().then(function(data) {
        return { ok: r.ok, data: data };
      });
    });
  }

  function cartHasVariant(cart, variantIdNum) {
    return (cart && cart.items ? cart.items : []).some(function(i) {
      return parseInt(i.variant_id, 10) === variantIdNum;
    });
  }

  function cartHasSubscriptionLine(cart) {
    return (cart && cart.items ? cart.items : []).some(function(i) {
      return i && i.selling_plan_allocation != null;
    });
  }

  function cartHasNonBonusSubscriptionLine(cart) {
    return (cart && cart.items ? cart.items : []).some(function(i) {
      return i && i.selling_plan_allocation != null && !isSubscriptionBonusVariantId(i.variant_id);
    });
  }

  function cartHasBonusWithCorrectPlan(cart, targetVid) {
    var target = parseInt(targetVid, 10);
    return (cart && cart.items ? cart.items : []).some(function(i) {
      if (!i || parseInt(i.variant_id, 10) !== target) return false;
      var planId = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan
        ? parseInt(i.selling_plan_allocation.selling_plan.id, 10)
        : null;
      return planId === SUBSCRIPTION_BONUS_SELLING_PLAN_ID;
    });
  }

  function getSubscriptionBonusLine(cart, targetVid) {
    var target = parseInt(targetVid, 10);
    return (cart && cart.items ? cart.items : []).find(function(i) {
      return i && parseInt(i.variant_id, 10) === target;
    });
  }

  function ensureBonusLineHasSellingPlan(cart, targetVid) {
    var line = getSubscriptionBonusLine(cart, targetVid);
    if (!line || cartHasBonusWithCorrectPlan(cart, targetVid)) {
      return Promise.resolve(cart);
    }
    pauseCartSideEffects(700);
    if (!line.selling_plan_allocation) {
      return cartChangeWithSections(
        { id: String(line.key), quantity: 0 },
        'subscribe-popover-bonus-ensure'
      ).then(function() {
        return addSubscriptionBonusLineWithSections(targetVid, 1, 'subscribe-popover-bonus-ensure').then(function(result) {
          if (!result.ok) return null;
          return result.data;
        });
      });
    }
    return replaceSubscriptionLinePlan(line, SUBSCRIPTION_BONUS_SELLING_PLAN_ID).then(function() {
      return cartFetch();
    });
  }

  function cartHasWrongSubscriptionBonus(cart, targetVid) {
    return SUBSCRIPTION_BONUS_VARIANT_IDS.some(function(id) {
      return id !== targetVid && cartHasVariant(cart, id);
    });
  }

  function removeBonusLinesFromCart(cart) {
    var bonusLines = (cart && cart.items ? cart.items : []).filter(function(i) {
      return i && isSubscriptionBonusVariantId(i.variant_id);
    });
    if (!bonusLines.length) return Promise.resolve(cart);
    var queue = Promise.resolve(null);
    bonusLines.forEach(function(line, index) {
      queue = queue.then(function() {
        return cartChangeWithSections(
          { id: String(line.key), quantity: 0 },
          index === bonusLines.length - 1 ? 'subscribe-popover-bonus-cleanup' : 'subscribe-popover-cart-mutation'
        );
      });
    });
    return queue;
  }

  /** Single pass: add or remove subscription bonus based on current cart. */
  function syncSubscriptionBonusFromCartState() {
    if (isCartMutationBusy()) {
      scheduleSyncSubscriptionBonus();
      return Promise.resolve();
    }
    isReconcilingBonus = true;
    planMutationDepth++;
    return cartFetch()
      .then(function(cart) {
        if (!cart || isCartSideEffectsPaused()) return null;
        var targetBonusVid = getSubscriptionBonusVariantId();
        var hasSub = cartHasNonBonusSubscriptionLine(cart);
        var hasTargetBonus = cartHasBonusWithCorrectPlan(cart, targetBonusVid);
        var hasWrongBonus = cartHasWrongSubscriptionBonus(cart, targetBonusVid);
        var hasBonusNeedingPlan =
          hasSub && cartHasVariant(cart, targetBonusVid) && !hasTargetBonus;

        if (hasBonusNeedingPlan) {
          pauseCartSideEffects(700);
          return ensureBonusLineHasSellingPlan(cart, targetBonusVid);
        }
        if (hasSub && hasWrongBonus) {
          pauseCartSideEffects(700);
          return removeBonusLinesFromCart(cart).then(function(updatedCart) {
            if (hasTargetBonus) return updatedCart;
            return addSubscriptionBonusLineWithSections(targetBonusVid, 1, 'subscribe-popover-bonus-ensure').then(function(result) {
              if (!result.ok) return null;
              return result.data;
            });
          });
        }
        if (hasSub && !hasTargetBonus) {
          pauseCartSideEffects(700);
          return addSubscriptionBonusLineWithSections(targetBonusVid, 1, 'subscribe-popover-bonus-ensure').then(function(result) {
            if (!result.ok) return null;
            return result.data;
          });
        }
        if (!hasSub && (hasTargetBonus || hasWrongBonus || cartHasVariant(cart, targetBonusVid))) {
          pauseCartSideEffects(700);
          return removeBonusLinesFromCart(cart);
        }
        return null;
      })
      .catch(function() {})
      .then(function() {
        isReconcilingBonus = false;
        planMutationDepth = Math.max(0, planMutationDepth - 1);
      });
  }

  function scheduleSyncSubscriptionBonus() {
    if (bonusSyncTimer) clearTimeout(bonusSyncTimer);
    bonusSyncTimer = setTimeout(function() {
      bonusSyncTimer = null;
      syncSubscriptionBonusFromCartState();
    }, CART_SIDE_EFFECTS_DELAY_MS);
  }

  function runDeferredCartSideEffects() {
    if (isUserLineRemoveActive() || isCartMutationBusy()) {
      scheduleDeferredCartSideEffects();
      return;
    }
    lockCheckoutForSubscriptionUpdate();
    reconcilePlansFromCartState(function() {
      scheduleSyncSubscriptionBonus();
      afterPlansAndBonusSettled(function() {
        awaitingDeferredSideEffects = false;
        tryUnlockCheckoutForSubscriptionUpdate();
      });
    });
  }

  function scheduleDeferredCartSideEffects() {
    awaitingDeferredSideEffects = true;
    lockCheckoutForSubscriptionUpdate();
    if (cartSideEffectsTimer) clearTimeout(cartSideEffectsTimer);
    cartSideEffectsTimer = setTimeout(function() {
      cartSideEffectsTimer = null;
      runDeferredCartSideEffects();
    }, DEFERRED_SIDE_EFFECTS_MS);
  }

  function schedulePostRemoveSideEffects(gen) {
    awaitingPostRemoveSideEffects = true;
    lockCheckoutForSubscriptionUpdate();
    setTimeout(function tick() {
      if (gen !== userLineRemoveGeneration) return;
      if (isUserLineRemoveActive() || isCartMutationBusy()) {
        setTimeout(tick, 400);
        return;
      }
      reconcilePlansFromCartState(function() {
        scheduleSyncSubscriptionBonus();
        afterPlansAndBonusSettled(function() {
          if (gen !== userLineRemoveGeneration) return;
          awaitingPostRemoveSideEffects = false;
          tryUnlockCheckoutForSubscriptionUpdate();
        });
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              data: { source: 'tybo-post-remove-complete' }
            }
          })
        );
      });
    }, POST_REMOVE_SIDE_EFFECTS_MS);
  }

  /**
   * Use Horizon cart-items-component removal (sections + morph). Prevents duplicate
   * on:click handler and wrong line-index removals.
   */
  function bindCartLineRemoveByKey() {
    if (bindCartLineRemoveByKey._done) return;
    bindCartLineRemoveByKey._done = true;
    document.addEventListener(
      'click',
      function(e) {
        var btn = e.target.closest('.cart-items__remove');
        if (!btn || btn.hasAttribute('hidden')) return;
        var cartComponent = btn.closest('cart-items-component');
        if (!cartComponent) return;
        var row = btn.closest('tr[data-key]');
        var lineKey =
          (btn.getAttribute('data-cart-line-key') || '').trim() ||
          (row && row.getAttribute('data-key')) ||
          '';
        if (!lineKey) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var lineIndex = getLineIndexForKey(cartComponent, lineKey);
        if (!lineIndex) return;

        markUserLineRemove();

        if (typeof cartComponent.onLineItemRemove === 'function') {
          cartComponent.onLineItemRemove(lineIndex);
        }
      },
      true
    );
  }

  /** After subscribe-from-popover succeeds: ensure bonus SKU is in cart (qty 1, subscription plan) if missing. */
  function ensureSubscriptionBonusProduct(cart) {
    var vid = getSubscriptionBonusVariantId();
    if (!cart) return Promise.resolve(cart);
    if (cartHasBonusWithCorrectPlan(cart, vid)) {
      return Promise.resolve(cart);
    }
    if (cartHasVariant(cart, vid)) {
      return ensureBonusLineHasSellingPlan(cart, vid);
    }
    return addSubscriptionBonusLine(vid, 1).then(function(result) {
      if (!result.ok) return cart;
      return cartFetch();
    });
  }

  function addSubscriptionLineWithFallback(variantId, qty, preferredPlanId, fallbackPlanId) {
    var preferred = parseInt(preferredPlanId, 10);
    var fallback = fallbackPlanId ? parseInt(fallbackPlanId, 10) : null;
    var variant = parseInt(variantId, 10);
    var invalidKey = String(variant) + ':' + String(preferred);

    // If this variant+plan already failed once, skip directly to fallback.
    if (invalidPlanByVariant[invalidKey]) {
      if (fallback && fallback !== preferred) {
        return addSubscriptionLine(variant, qty, fallback);
      }
      return Promise.resolve({ ok: false, data: { description: 'Preferred selling plan is invalid for this variant' } });
    }

    return addSubscriptionLine(variant, qty, preferred).then(function(result) {
      if (result.ok) return result;

      // Mark as invalid to avoid repeated 422 attempts in normalization flow.
      invalidPlanByVariant[invalidKey] = true;

      // Fallback to line-specific plan if preferred plan is rejected by Shopify (422).
      if (fallback && fallback !== preferred) {
        return addSubscriptionLine(variant, qty, fallback);
      }
      return result;
    });
  }

  function postCartChangeJson(url, payload, attempt) {
    var tryNum = attempt || 0;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r) {
      return r.text().then(function(text) {
        var data = {};
        if (text) {
          try {
            data = JSON.parse(text);
          } catch (parseErr) {
            data = { description: text.slice(0, 120) };
          }
        }
        if ((r.status === 429 || r.status === 503) && tryNum < CART_CHANGE_RETRY_MAX) {
          return new Promise(function(resolve) {
            setTimeout(resolve, 700 + tryNum * 600);
          }).then(function() {
            return postCartChangeJson(url, payload, tryNum + 1);
          });
        }
        return { ok: r.ok, status: r.status, data: data };
      });
    });
  }

  function replaceSubscriptionLinePlan(lineItem, targetSellingPlanId) {
    var qty = Math.max(1, parseInt(lineItem.quantity, 10) || 1);
    var variantId = parseInt(lineItem.variant_id, 10);
    var planId = parseInt(targetSellingPlanId, 10);
    var fallbackPlanId = lineItem.selling_plan_allocation && lineItem.selling_plan_allocation.selling_plan
      ? parseInt(lineItem.selling_plan_allocation.selling_plan.id, 10)
      : null;
    var changePayload = {
      id: String(lineItem.key),
      quantity: qty,
      selling_plan: planId
    };

    /** In-place plan change — avoids remove+re-add racing theme line-index removal. */
    return postCartChangeJson(root + 'cart/change.js', changePayload)
      .then(function(result) {
        if (result.ok) return result.data;
        if (fallbackPlanId && fallbackPlanId !== planId) {
          return postCartChangeJson(root + 'cart/change.js', {
            id: String(lineItem.key),
            quantity: qty,
            selling_plan: fallbackPlanId
          }).then(function(result2) {
            if (!result2.ok) {
              throw new Error(
                (result2.data && (result2.data.description || result2.data.message)) ||
                  'Could not update subscription plan'
              );
            }
            return result2.data;
          });
        }
        return addSubscriptionLineWithFallback(variantId, qty, planId, fallbackPlanId).then(function(addResult) {
          if (!addResult.ok) {
            throw new Error(
              (addResult.data && (addResult.data.description || addResult.data.message)) ||
                'Could not update subscription plan'
            );
          }
          return addResult.data;
        });
      });
  }

  /** Lines that use global 10%/15% plans (Creatine + sample pack use their own plans). */
  function getGlobalPlanSubscriptionLines(cart) {
    return (cart && cart.items ? cart.items : []).filter(function(i) {
      return (
        i &&
        i.selling_plan_allocation != null &&
        !isCreatineCartVariantId(i.variant_id) &&
        !isSubscriptionBonusVariantId(i.variant_id)
      );
    });
  }

  function getTargetPlanForCart(cart) {
    var subscriptionLines = getGlobalPlanSubscriptionLines(cart);
    if (!subscriptionLines.length) return null;
    var totalSubscriptionQty = subscriptionLines.reduce(function(sum, line) {
      return sum + (parseInt(line.quantity, 10) || 0);
    }, 0);
    return totalSubscriptionQty >= 2
      ? MULTI_SUBSCRIPTION_SELLING_PLAN_ID
      : SUBSCRIPTION_SELLING_PLAN_ID;
  }

  function needsPlanNormalization(cart) {
    var targetSellingPlanId = getTargetPlanForCart(cart);
    if (!targetSellingPlanId) return false;
    var subscriptionLines = getGlobalPlanSubscriptionLines(cart);
    return subscriptionLines.some(function(line) {
      var currentPlanId = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
        ? parseInt(line.selling_plan_allocation.selling_plan.id, 10)
        : null;
      return currentPlanId !== targetSellingPlanId;
    });
  }

  function normalizeSubscriptionPlans(cart) {
    var subscriptionLines = getGlobalPlanSubscriptionLines(cart);
    if (!subscriptionLines.length) return Promise.resolve(cart);

    var targetSellingPlanId = getTargetPlanForCart(cart);

    var needsUpdate = subscriptionLines.some(function(line) {
      var currentPlanId = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
        ? parseInt(line.selling_plan_allocation.selling_plan.id, 10)
        : null;
      return currentPlanId !== targetSellingPlanId;
    });

    if (!needsUpdate) return Promise.resolve(cart);

    planMutationDepth++;
    var queue = Promise.resolve();
    subscriptionLines.forEach(function(line) {
      queue = queue.then(function() {
        var currentPlanId = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
          ? parseInt(line.selling_plan_allocation.selling_plan.id, 10)
          : null;
        if (currentPlanId === targetSellingPlanId) return;
        return replaceSubscriptionLinePlan(line, targetSellingPlanId);
      });
    });

    return queue
      .then(function() { return cartFetch(); })
      .finally(function() {
        planMutationDepth--;
      });
  }

  function reconcilePlansFromCartState(done) {
    if (isReconcilingPlans) {
      setTimeout(function() {
        reconcilePlansFromCartState(done);
      }, 220);
      return;
    }
    var now = Date.now();
    if (now - lastReconcileAt < RECONCILE_MIN_INTERVAL_MS) {
      var waitMs = RECONCILE_MIN_INTERVAL_MS - (now - lastReconcileAt) + 80;
      if (!reconcileRetryTimer) {
        reconcileRetryTimer = setTimeout(function() {
          reconcileRetryTimer = null;
          reconcilePlansFromCartState(done);
        }, waitMs);
      } else if (typeof done === 'function') {
        // Existing retry already scheduled — still honor this done() so checkout can unlock.
        setTimeout(function() {
          reconcilePlansFromCartState(done);
        }, waitMs);
      }
      return;
    }
    if (isCartMutationBusy()) {
      setTimeout(function() {
        reconcilePlansFromCartState(done);
      }, 220);
      return;
    }
    isReconcilingPlans = true;
    cartFetch()
      .then(function(cart) {
        if (!cart || isCartSideEffectsPaused() || !needsPlanNormalization(cart)) return null;
        lastReconcileAt = Date.now();
        pauseCartSideEffects(1500);
        return normalizeSubscriptionPlans(cart).then(function(finalCart) {
          if (finalCart && needsPlanNormalization(finalCart)) {
            return finalCart;
          }
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: finalCart || null,
              data: { source: 'subscribe-popover-plan-reconcile' }
            }
          }));
          return finalCart;
        });
      })
      .catch(function() {})
      .then(function() {
        isReconcilingPlans = false;
        if (typeof done === 'function') done();
      });
  }

  function convertToSubscription(btn, popover) {
    var variantId = btn.getAttribute('data-variant-id');
    var itemKey = (btn.getAttribute('data-item-key') || '').trim();
    var planFromButton = btn.getAttribute('data-selling-plan-id');
    var sellingPlanId = planFromButton ? parseInt(planFromButton, 10) : SUBSCRIPTION_SELLING_PLAN_ID;
    var frequencySelect = getFrequencySelectInPopover(popover);
    var userFrequencyPlanId = frequencySelect && frequencySelect.value ? parseInt(frequencySelect.value, 10) : null;
    if (!variantId || !itemKey) return;
    if (
      frequencySelect &&
      isCreatineCartVariantId(variantId) &&
      !frequencySelect.value
    ) {
      return;
    }

    var originalContent = btn.innerHTML;
    var loadingLabel = (btn.getAttribute('data-loading-label') || 'Subscribing...').trim();
    btn.disabled = true;
    btn.classList.add('popover-subscribe-btn--loading');
    btn.innerHTML = '<span class="popover-subscribe-btn__spinner" aria-hidden="true"></span><span class="popover-subscribe-btn__loading-text">' + loadingLabel + '</span>';
    pauseCartSideEffects(1500);
    awaitingDeferredSideEffects = true;
    lockCheckoutForSubscriptionUpdate();

    cartFetch()
      .then(function(cart) {
        var items = cart.items || [];
        var item = items.find(function(i) { return i.key === itemKey; });
        if (!item) {
          throw new Error('Item not found in cart. Please refresh and try again.');
        }
        var keyFromCart = item.key;
        var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
        function removeLineByKey(key) {
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: String(key), quantity: 0 })
          }).then(function(r) {
            return r.json().then(function(data) {
              if (!r.ok) throw new Error(data.description || data.message || 'Could not remove item ('.concat(r.status, ')'));
              return data;
            });
          });
        }
        return removeLineByKey(keyFromCart)
          .then(function() { return new Promise(function(go) { setTimeout(go, 150); }); })
          .then(cartFetch)
          .then(function(cartAfterRemove) {
            var stillThere = (cartAfterRemove.items || []).find(function(i) { return i.key === itemKey || i.key === keyFromCart; });
            if (stillThere) {
              return removeLineByKey(stillThere.key)
                .then(function() { return new Promise(function(go) { setTimeout(go, 150); }); })
                .then(cartFetch);
            }
            return cartAfterRemove;
          })
          .then(function(cartBeforeAdd) {
            var oneTimeStillThere = (cartBeforeAdd.items || []).some(function(i) { return i.key === itemKey; });
            if (oneTimeStillThere) {
              throw new Error('Could not remove one-time item. Please try again.');
            }

            if (userFrequencyPlanId) {
              sellingPlanId = userFrequencyPlanId;
            } else {
              // Plan selection rule:
              // - total subscription quantity < 2 => 10% plan
              // - total subscription quantity >= 2 (including qty=2 of same product) => 15% plan
              var existingSubscriptionQty = (cartBeforeAdd.items || []).reduce(function(sum, i) {
                if (!i || i.selling_plan_allocation == null) return sum;
                return sum + (parseInt(i.quantity, 10) || 0);
              }, 0);
              var resultingSubscriptionQty = existingSubscriptionQty + qty;
              sellingPlanId = resultingSubscriptionQty >= 2
                ? MULTI_SUBSCRIPTION_SELLING_PLAN_ID
                : SUBSCRIPTION_SELLING_PLAN_ID;
            }

            return addSubscriptionLineWithFallback(variantId, qty, sellingPlanId, planFromButton);
          })
          .then(function(result) {
            if (!result.ok && result.data && result.data.description) {
              throw new Error(result.data.description);
            }
            if (result.data && result.data.status === 422) {
              throw new Error(result.data.description || 'Could not add subscription');
            }
            closePopover(popover);
            return cartFetch();
          })
          .then(function(updatedCart) {
            var variantIdNum = parseInt(variantId, 10);
            var lineWeAdded = (updatedCart.items || []).find(function(i) {
              return i.selling_plan_allocation != null && i.variant_id === variantIdNum;
            });
            if (lineWeAdded && lineWeAdded.quantity > qty) {
              return fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: lineWeAdded.key, quantity: qty })
              }).then(function(r) { return r.ok ? r.json() : updatedCart; }).then(function(c) { return c || updatedCart; });
            }
            return updatedCart;
          })
          .then(function(cartAfterQtyFix) {
            return normalizeSubscriptionPlans(cartAfterQtyFix);
          })
          .then(function(finalCart) {
            return ensureSubscriptionBonusProduct(finalCart);
          })
          .then(function(finalCart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: finalCart || null,
                data: { source: 'subscribe-popover-cart' }
              }
            }));
          });
      })
      .catch(function() {})
      .then(function() {
        btn.disabled = false;
        btn.classList.remove('popover-subscribe-btn--loading');
        btn.innerHTML = originalContent;
        afterPlansAndBonusSettled(function() {
          awaitingDeferredSideEffects = false;
          tryUnlockCheckoutForSubscriptionUpdate();
        });
      });
  }

  function bindPopoverCta(popover) {
    var btn = popover.querySelector('.popover-subscribe-btn');
    if (!btn || btn.getAttribute(BOUND)) return;
    btn.setAttribute(BOUND, '1');
    btn.addEventListener('click', function(e) {
      if (btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var itemKey = btn.getAttribute('data-item-key');
      var variantId = btn.getAttribute('data-variant-id');
      if (itemKey && variantId) {
        convertToSubscription(btn, popover);
      } else {
        closePopover(popover);
      }
    });
  }

  function onDocumentClick(e) {
    var triggerBtn = e.target.closest('.subscribe-upgrade-btn');
    if (triggerBtn) {
      e.preventDefault();
      e.stopPropagation();
      openPopoverForButton(triggerBtn);
      return;
    }

    var ctaBtn = e.target.closest('.popover-subscribe-btn');
    if (ctaBtn) {
      if (ctaBtn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var popover = ctaBtn.closest('.subscribe-popover');
      var itemKey = ctaBtn.getAttribute('data-item-key');
      var variantId = ctaBtn.getAttribute('data-variant-id');
      if (itemKey && variantId) {
        convertToSubscription(ctaBtn, popover);
      } else if (popover) {
        closePopover(popover);
      }
      return;
    }

    if (e.target.closest('.subscribe-popover')) return;
    var openPopover = document.querySelector('.subscribe-popover[data-subscribe-open]');
    if (openPopover) {
      var active = document.activeElement;
      if (
        active &&
        active.closest &&
        active.closest('.subscribe-popover') === openPopover &&
        active.matches &&
        active.matches('.subscribe-popover-frequency-select')
      ) {
        return;
      }
    }
    closeAllOpen();
  }

  function init() {
    document.querySelectorAll('.subscribe-upgrade-btn').forEach(bindButton);
    document.querySelectorAll('.subscribe-popover').forEach(function(popover) {
      bindPopoverCta(popover);
      syncSubscribeCtaFromFrequencySelect(popover);
    });
  }

  function bindCartCreatineLineFrequencyChange() {
    if (bindCartCreatineLineFrequencyChange._done) return;
    bindCartCreatineLineFrequencyChange._done = true;
    document.addEventListener('change', function(e) {
      var sel = e.target;
      if (!sel || !sel.classList || !sel.classList.contains('cart-creatine-frequency-change-select')) return;
      var newPlanId = parseInt(sel.value, 10);
      if (!newPlanId) return;
      var itemKey = (sel.getAttribute('data-item-key') || '').trim();
      if (!itemKey) return;
      var previousPlanStr = sel.getAttribute('data-current-plan-id') || '';
      if (String(newPlanId) === String(previousPlanStr)) return;

      sel.disabled = true;
      lockCheckoutForSubscriptionUpdate();
      cartFetch()
        .then(function(cart) {
          var item = (cart.items || []).find(function(i) {
            return i.key === itemKey;
          });
          if (!item) throw new Error('Cart line not found');
          var curPlan =
            item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
              ? parseInt(item.selling_plan_allocation.selling_plan.id, 10)
              : null;
          if (curPlan === newPlanId) return cart;
          if (!isCreatineCartVariantId(item.variant_id)) throw new Error('Not creatine line');
          planMutationDepth++;
          return replaceSubscriptionLinePlan(item, newPlanId)
            .then(function() {
              return cartFetch();
            })
            .finally(function() {
              planMutationDepth--;
            });
        })
        .then(function(cart) {
          sel.setAttribute('data-current-plan-id', String(newPlanId));
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart || null,
                data: { source: 'cart-creatine-frequency-change' }
              }
            })
          );
        })
        .catch(function() {
          try {
            if (previousPlanStr) sel.value = previousPlanStr;
          } catch (ignore) {}
        })
        .finally(function() {
          sel.disabled = false;
          tryUnlockCheckoutForSubscriptionUpdate();
        });
    });
  }

  bindCartCreatineLineFrequencyChange();
  bindSubscribePopoverFrequencySelectSync();
  bindCartLineRemoveByKey();
  bindCheckoutSubmitGuard();

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllOpen();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);
  document.addEventListener('cart:update', function(e) {
    setTimeout(init, 100);
    setTimeout(refreshCheckoutLockUi, 50);
    setTimeout(refreshCheckoutLockUi, 300);
    var src = e.detail && e.detail.data && e.detail.data.source;
    if (isInternalCartUpdateSource(src)) return;

    if (src === 'cart-items-component') {
      if (isUserLineRemoveActive()) {
        schedulePostRemoveSideEffects(userLineRemoveGeneration);
      } else {
        scheduleDeferredCartSideEffects();
      }
      return;
    }

    scheduleDeferredCartSideEffects();
  });
})();
